////  ESEMPIO CONVERSIONE ENUM
//option.key DocumentoInUscita
//IProtocol_Type[option.key] -> 1
//IProtocol_Type[IProtocol_Type[option.key]] -> DocumentoInUscita

import { IDropdownOption } from "@fluentui/react";


export enum Contact_Type {
    Undefined = 'Undefined',
    PersonaFisica = 'PersonaFisica',
    PersonaGiuridica = 'PersonaGiuridica',
    Amministrazione = 'Amministrazione',
    AmministrazioneEstera = 'AmministrazioneEstera'
}
export const Contact_Type_Label = new Map<string, string>([
    [Contact_Type.Undefined, ''],
    [Contact_Type.PersonaFisica, 'Persona fisica'],
    [Contact_Type.PersonaGiuridica, 'Persona giuridica'],
    [Contact_Type.Amministrazione, 'Amministrazione'],
    [Contact_Type.AmministrazioneEstera, 'Amministrazione estera']
]);


export enum Protocol_State {
    Undefined = 'Undefined',
    InCreazione = 'InCreazione',
    InCreazioneDaMail = 'InCreazioneDaMail',
    Allocato = 'Allocato',
    Prenotato = 'Prenotato',
    Acquisito = 'Acquisito',
    Protocollato = 'Protocollato',
    Annullato = 'Annullato',
}


export const Protocol_State_Label = new Map<string, string>([
    [Protocol_State.Undefined, ''],
    [Protocol_State.InCreazione, 'In creazione'],
    [Protocol_State.InCreazioneDaMail, 'In creazione da mail'],
    [Protocol_State.Allocato, 'Allocato'],
    [Protocol_State.Prenotato, 'Prenotato'],
    [Protocol_State.Acquisito, 'Acquisito'],
    [Protocol_State.Protocollato, 'Protocollato'],
    [Protocol_State.Annullato, 'Annullato']
]);

export enum Protocol_Type {
    Undefined = 'Undefined',
    DocumentoInEntrata = 'DocumentoInEntrata',
    DocumentoInUscita = 'DocumentoInUscita',
    DocumentoInterno = 'DocumentoInterno'
}

export const Protocol_Type_Label = new Map<string, string>([
    [Protocol_Type.Undefined, ''],
    [Protocol_Type.DocumentoInEntrata, 'Documento in entrata'],
    [Protocol_Type.DocumentoInUscita, 'Documento in uscita'],
    [Protocol_Type.DocumentoInterno, 'Documento interno']
]);


export enum AddEditUserAoo_Mode {
    Undefined = 'Undefined',
    AddUser = 'AddUser',
    EditUserOnly = 'EditUserOnly',
    EditUserAndRole = 'EditUserAndRole'
}
export enum ProtocolloAreaDiLavoroEF_Priority {
    Undefined = 'Undefined',
    Bassa = 'Bassa',
    Media = 'Media',
    Alta = 'Alta'
}
//export const ProtocolloAreaDiLavoroEF_Priority_Label = new Map<string, string>([
//    [ProtocolloAreaDiLavoroEF_Priority.Undefined, ''],
//    [ProtocolloAreaDiLavoroEF_Priority.Bassa, 'Bassa'],
//    [ProtocolloAreaDiLavoroEF_Priority.Media, 'Media'],
//    [ProtocolloAreaDiLavoroEF_Priority.Alta, 'Alta']
//]);

export enum ProtocolloAreaDiLavoroEF_State {
    Undefined = 'Undefined',
    DaLeggere = 'DaLeggere',
    InLavorazione = 'InLavorazione',
    Lavorato = 'Lavorato'
}
export const ProtocolloAreaDiLavoroEF_State_Label = new Map<string, string>([
    [ProtocolloAreaDiLavoroEF_State.Undefined, ''],
    [ProtocolloAreaDiLavoroEF_State.DaLeggere, 'Da leggere'],
    [ProtocolloAreaDiLavoroEF_State.InLavorazione, 'In lavorazione'],
    [ProtocolloAreaDiLavoroEF_State.Lavorato, 'Lavorato']
]);

export enum Protocol_ConfirmAction {
    Undefined = 'Undefined',
    CreaCanaleTeams = 'CreaCanaleTeams',
    AcquisisciDocumento = 'AcquisisciDocumento',
    ProtocollaDocumento = 'ProtocollaDocumento',
    AnnullaProtocollo = 'AnnullaProtocollo',
    ArchiviaProtocollo = 'ArchiviaProtocollo',
    EliminaBozza = 'EliminaBozza',
    EliminaAllegato = 'EliminaAllegato'

}

export enum ProtocolDispatchEF_Status {
    Undefined = 'Undefined',
    DaInviare = 'DaInviare',
    Errore = 'Errore',
    InAttesa = 'InAttesa',
    NonAccettata = 'NonAccettata',
    CompletataConErrori = 'CompletataConErrori',
    Completata = 'Completata'
}
export const ProtocolDispatchEF_Status_Label = new Map<string, string>([
    [ProtocolDispatchEF_Status.Undefined, ''],
    [ProtocolDispatchEF_Status.DaInviare, 'Da inviare'],
    [ProtocolDispatchEF_Status.Errore, 'Errore'],
    [ProtocolDispatchEF_Status.InAttesa, 'In attesa'],
    [ProtocolDispatchEF_Status.NonAccettata, 'Non accettata'],
    [ProtocolDispatchEF_Status.CompletataConErrori, 'Completata con errori'],
    [ProtocolDispatchEF_Status.Completata, 'Completata']
]);

export enum ProtocolRegisterSP_Tipologia {
    Undefined = 'Undefined',
    Giornaliero = 'Giornaliero',
    Annuale = 'Annuale'
}

export const ProtocolRegisterSP_Tipologia_Label = new Map<string, string>([
    [ProtocolRegisterSP_Tipologia.Undefined, ''],
    [ProtocolRegisterSP_Tipologia.Giornaliero, 'Giornaliero'],
    [ProtocolRegisterSP_Tipologia.Annuale, 'Annuale']
]);
export enum Visibility_Type {
    Undefined = 'Undefined',
    Proprietario = 'Proprietario',
    Inoltro = 'Inoltro',
    CopiaConoscenza = 'CopiaConoscenza',
    Visibilita = 'Visibilita'
}
export const Visibility_Type_Label = new Map<string, string>([
    [Visibility_Type.Undefined, ''],
    [Visibility_Type.Proprietario, 'Proprietario'],
    [Visibility_Type.Inoltro, 'Inoltro'],
    [Visibility_Type.CopiaConoscenza, 'Copia conoscenza'],
    [Visibility_Type.Visibilita, 'Visibilità']
]);

export enum ForwardRuleUor_Type {
    Undefined = 'Undefined',
    Inoltro = 'Inoltro',
    CopiaConoscenza = 'CopiaConoscenza'
}
export const ForwardRuleUor_Type_Label = new Map<string, string>([
    [ForwardRuleUor_Type.Undefined, ''],
    [ForwardRuleUor_Type.Inoltro, 'Inoltro'],
    [ForwardRuleUor_Type.CopiaConoscenza, 'Copia conoscenza']
]);



export enum LabelOrientation {
    Undefined = 'Undefined',
    Orizzontale = 'Orizzontale',
    Verticale = 'Verticale'
}

export enum Indici_FormMode {
    Undefined = 'Undefined',
    Create = 'Create',
    Edit = 'Edit',
    Search = 'Search',
    SearchAreaLavoro = 'SearchAreaLavoro',
    ReadOnly = 'ReadOnly',
    CreateForwardRule = 'CreateForwardRule'
}

export enum Visibilita_ViewMode {
    Undefined = 'Undefined',
    ActiveOnly = 'ActiveOnly',
    Expanded = 'Expanded'
}

export enum Search_QueryOperator {
    Undefined = 'Undefined',
    Equals = 'Equals',
    Contains = 'Contains'
}


export enum Fascicolo_Type {
    Undefined = 'Undefined',
    Affare = 'Affare',
    Attivita = 'Attivita',
    Procedimento = 'Procedimento',
    PersonaFisica = 'PersonaFisica',
    PersonaGiuridica = 'PersonaGiuridica'

}


export const Fascicolo_Type_Label = new Map<string, string>([
    [Fascicolo_Type.Undefined, ''],
    [Fascicolo_Type.Affare, 'Affare'],
    [Fascicolo_Type.Attivita, 'Attività'],
    [Fascicolo_Type.Procedimento, 'Procedimento'],
    [Fascicolo_Type.PersonaFisica, 'Persona fisica'],
    [Fascicolo_Type.PersonaGiuridica, 'Persona giuridica']
]);

export enum Wizard_Mode {
    Create = 'Create',
    CreateFrom = 'CreateFrom',
    PrintLabel = 'PrintLabel',
    Edit = 'Edit',
    Reload = 'Reload',
    Acquired = 'Acquired',
    Allocated = 'Allocated'
}

export const Wizard_Mode_Path = new Map<string, string>([
    [Wizard_Mode.Create, '/:aooId/new'],
    [Wizard_Mode.CreateFrom, '/:aooId/createfrom/:id'],
    [Wizard_Mode.Edit, '/:aooId/edit/:id'],
    [Wizard_Mode.Reload, '/:aooId/reload/:id'],
    [Wizard_Mode.Acquired, '/:aooId/acquired/:id/:protocolnumber'],
    [Wizard_Mode.Allocated, '/:aooId/allocated/:id/:protocolnumber'],
]);


export enum RoleContext {
    Undefined = 'Undefined',
    Aoo = 'Aoo',
    Uor = 'Uor'
}

export enum Search_Type {
    Tutto = 'Tutto',
    Protocollo = 'Protocollo',
    Documenti = 'Documenti'
}
//export enum Search_Mode {
//    AllProtocols = 0, // restituisce tutti i protocolli che soddisfano i parametri di ricerca (per i protocolli sui quali non si hanno diritti è visibile solo il numero di protocollo )
//    BasedOnVisibility = 1 // restituisce tutti i protocolli che soddisfano i parametri di ricerca e i criteri di visibilità
//}

export enum MailboxUor_Type {
    Udenfined = 'Udenfined',
    In = 'In',
    Out = 'Out'
}

export enum RichiestaAnnullamento_Status {
    Undefined = 'Undefined',
    InCorso = 'InCorso',
    Annullata = 'Annullata',
    Rifiutata = 'Rifiutata',
    Approvata = 'Approvata'
}

export const RichiestaAnnullamento_Status_Label = new Map<string, string>([
    [RichiestaAnnullamento_Status.Undefined, ''],
    [RichiestaAnnullamento_Status.InCorso, 'In Corso'],
    [RichiestaAnnullamento_Status.Annullata, 'Annullata'],
    [RichiestaAnnullamento_Status.Rifiutata, 'Rifiutata'],
    [RichiestaAnnullamento_Status.Approvata, 'Approvata']
]);


export enum CampoVersioneEF_Status {
    Unchanged = 'Unchanged',
    Modified = 'Modified',
    New = 'New',
    Deleted = 'Deleted'
}


export const CampoVersioneEF_Status_Label = new Map<string, string>([
    [CampoVersioneEF_Status.Unchanged, 'Unchanged'],
    [CampoVersioneEF_Status.Modified, 'Modificato'],
    [CampoVersioneEF_Status.New, 'Nuovo'],
    [CampoVersioneEF_Status.Deleted, 'Eliminato'],
]);


export enum DocumentLoading_State {
    NoData = 'NoData',
    Loading = 'Loading',
    LoadSuccess = 'LoadSuccess',
    LoadError = 'LoadError',
}

export enum DimensionFile_Unit {
    B = 'B',
    KB = 'KB',
    MB = 'MB',
    GB = 'GB',
    TB = 'TB'
}

export enum FilterEF_Operator {
    Equals = 'Equals',
    NotEquals = 'NotEquals',
    GreaterThan = 'GreaterThan',
    GreaterEquals = 'GreaterEquals',
    LessThan = 'LessThan',
    LessEquals = 'LessEquals',
    IsNull = 'IsNull',
    IsNotNull = 'IsNotNull',
    StringStartsWith = 'StringStartsWith',
    StringContains = 'StringContains',
    DateRanges = 'DateRanges',
    ListAny = 'ListAny'
}

export enum SortEF_Direction {
    Undefined = 'Undefined',
    Ascending = 'Ascending',
    Descending = 'Descending'
}
export enum DashboardPage {
    Undefined = 'Undefined',
    Today = '/:aooId/today',
    Acquired = '/:aooId/acquired',
    Drafts = '/:aooId/drafts',
    Workspace = '/:aooId/workspace'
}
export enum DataType {
    DateTime = 'DateTime',
    Boolean = 'Boolean',
    Number = 'Number',
    Text = 'Text',
    Note = 'Note',
    Currency = 'Currency',
    Choice = 'Choice',
    Lookup = 'Lookup',
    LookupTitolario = 'LookupTitolario',
    LookupList = 'LookupList',
    User = 'User',
    Enumerator = 'Enumerator',
}

export const DataTypeLabels: Record<DataType, string> = {
    [DataType.DateTime]: 'Data',
    [DataType.Boolean]: 'Sì/No',
    [DataType.Number]: 'Numero',
    [DataType.Text]: 'Testo',
    [DataType.Note]: 'Note',
    [DataType.Currency]: 'Valuta',
    [DataType.Choice]: 'Scelta',
    [DataType.Lookup]: 'Ricerca',
    [DataType.LookupTitolario]: 'Ricerca verso Titolario',
    [DataType.LookupList]: 'Ricerca verso Elenco',
    [DataType.User]: 'Utente',
    [DataType.Enumerator]: 'Enumeratore',
};

const dataTypeSet = new Set(Object.values(DataType));
export function getLabelFromDataType(type: DataType): string {
    return DataTypeLabels[type];
}
export function getDataTypeFromLabel(label: string): DataType | undefined {
    return (Object.entries(DataTypeLabels) as [DataType, string][])
        .find(([, value]) => value === label)
        ?.[0];
}

export function tryGetDataType(raw: string | DataType): DataType | undefined {
    if (dataTypeSet.has(raw as DataType)) {
        return raw as DataType;
    }
    return getDataTypeFromLabel(raw);
}

export const DataTypeDropdownOptions = (
    allowed: readonly DataType[] = [
        DataType.DateTime,
        DataType.Boolean,
        DataType.Number,
        DataType.Text,
        DataType.Note,
        DataType.Currency,
        DataType.Choice,
        DataType.User
    ]
): IDropdownOption[] =>
    allowed.map(dt => ({
        key: dt,
        text: getLabelFromDataType(dt)
    }));

export enum TipologiaCartella {
    Inbox = 'Inbox',
    Cestino = 'Cestino',
    Anomalie = 'Anomalie',
    PostaInviata = 'PostaInviata',
    PostaInUscita = 'PostaInUscita',
    Bozze = 'Bozze',
    Cartella = 'Cartella'
}

export enum StatoSpedizioneEnum {
    NonDefinito = 'NonDefinito',
    Bozza = 'Bozza',
    InUscita = 'InUscita',
    Inviata = 'Inviata',
    InAttesa = 'InAttesa',
    NonAccettata = 'NonAccettata',
    CompletataConErrori = 'CompletataConErrori',
    Completata = 'Completata'
}

/// <summary>
/// Mail tipologia to use internally for categorizing mails.
/// </summary>
export enum MailTipologia {
    PostaInviata = 'PostaInviata',
    PostaCertificata = 'PostaCertificata',
    PostaNonCertificata = 'PostaNonCertificata',
    AnomaliaMessaggio = 'AnomaliaMessaggio',
    // Tipologia per gestire collisioni di chiave con contenuto differente
    PostaNonCertificataCollisioneChiave = 'PostaNonCertificataCollisioneChiave'
}


export enum AttachmentTipologia {
    /// <summary>
    /// Files attached from the sender to the email
    /// </summary>
    Allegato = 'Allegato',
    /// <summary>
    /// Files like eml that contain the mail itself
    /// </summary>
    Email = 'Email',
    /// <summary>
    /// Files that are present because of the Pec protocol. Previous was xml
    /// </summary>
    Daticert = 'Daticert'

}

export enum TipoRicevutaEnum {
    Accettazione = 'Accettazione',   // una sola riga 
    Destinatario = 'Destinatario',   // una riga per ogni To/Cc di qualsiasi tipo
    Informativo = 'Informativo '     // PresaInCarico, Preavviso 12/24h, RilevazioneVirus
}

export enum StatoRicevutaEnum {
    InAttesa = 'InAttesa',
    Accettato = 'Accettato',
    NonAccettato = 'NonAccettato',

    // Eventi non terminali
    PresaInCarico = 'PresaInCarico',
    PreavvisoErroreConsegna = 'PreavvisoErroreConsegna',

    // Sicurezza (evento informativo, non terminale)
    RilevazioneVirus = 'RilevazioneVirus',

    // Esiti finali
    Consegna = 'Consegna',
    MancataConsegna = 'MancataConsegna'

}
export const StatoRicevutaLabel = new Map<string, string>([
    [StatoRicevutaEnum.InAttesa, 'In attesa'],
    [StatoRicevutaEnum.Accettato, 'Accettato'],
    [StatoRicevutaEnum.NonAccettato, 'Non accettato'],
    [StatoRicevutaEnum.PresaInCarico, 'Presa in carico'],
    [StatoRicevutaEnum.PreavvisoErroreConsegna, 'Preavviso errore consegna'],
    [StatoRicevutaEnum.RilevazioneVirus, 'Rilevazione virus'],
    [StatoRicevutaEnum.Consegna, 'Consegna'],
    [StatoRicevutaEnum.MancataConsegna, 'Mancata consegna'],
]);

export enum TipoDestinatarioEnum {
    NonDefinito = 'NonDefinito',
    Esterno = 'Esterno',
    Certificato = 'Certificato'
}
export const TipoDestinatarioLabel = new Map<string, string>([
    [TipoDestinatarioEnum.NonDefinito, 'Non definito'],
    [TipoDestinatarioEnum.Esterno, 'Esterno'],
    [TipoDestinatarioEnum.Certificato, 'Certificato'],
]);

export enum SearchSortDirection {
    Ascending = 0,
    Descending = 1
}

export enum Log_Operation {
    get_aoo = 'get_aoo',
    create_protocol = 'create_protocol',
    create_protocol_from_draft = 'create_protocol_from_draft',
    create_protocol_draft = 'create_protocol_draft',
    update_protocol_draft = 'update_protocol_draft',
    delete_protocol_draft = 'delete_protocol_draft',
    reload_protocol = 'reload_protocol',
    update_protocol = 'update_protocol',
    update_registered_protocol = 'update_registered_protocol',
    register_protocol = 'register_protocol',
    undo_protocol = 'undo_protocol',
    get_protocol = 'get_protocol',
    get_attach_protocol = 'get_attach_protocol',
    get_file_protocol = 'get_file_protocol',
    get_audit_protocol = 'get_audit_protocol',
    add_attachment = 'add_attachment',
    delete_attachment = 'delete_attachment',
    get_user_active_aoo = 'get_user_active_aoo',
    get_features = 'get_features',
    get_feature = 'get_feature',
    update_features = 'update_features',
    can_activate_feature = 'can_activate_feature',
    get_configurations = 'get_configurations',
    get_configuration = 'get_configuration',
    update_configurations = 'update_configurations',
    get_fe_configurations = 'get_fe_configurations',
    get_fields_by_view_name = 'get_fields_by_view_name',
    get_fields_by_type = 'get_fields_by_type',
    get_all_fields = 'get_all_fields',
    get_lookup_suggestions = 'get_lookup_suggestions',
    get_protocols_uor = 'get_protocols_uor',
    get_protocols_as_stream = 'get_protocols_as_stream',
    search_protocols = 'search_protocols',
    get_organization_chart = 'get_organization_chart',
    add_uor = 'add_uor',
    get_users_uor = 'get_users_uor',
    add_user_uor = 'add_user_uor',
    update_user_uor = 'update_user_uor',
    delete_user_uor = 'delete_user_uor',
    get_user_info = 'get_user_info',
    get_user_suggestions = 'get_user_suggestions',
    add_user = 'add_user',
    get_roles = 'get_roles',
    get_user_roles = 'get_user_roles',
    get_filing_plan = 'get_filing_plan',
    add_filing_plan = 'add_filing_plan',
    get_forward_rules = 'get_forward_rules',
    get_forward_rule = 'get_forward_rule',
    create_forward_rule = 'create_forward_rule',
    update_forward_rule = 'update_forward_rule',
    delete_forward_rule = 'delete_forward_rule',
    update_filing_plan_protocol = 'update_filing_plan_protocol',
    update_visibilita_protocol = 'update_visibilita_protocol',
    get_uors_user_suggestions = 'get_uors_user_suggestions',
    get_user_visibilita_protocol = 'get_user_visibilita_protocol',
    get_protocol_visibility = 'get_protocol_visibility',
    evaluate_protocol_forward_rules = 'evaluate_protocol_forward_rules',
    get_contacts_pecmail = 'get_contacts_pecmail',
    send_mail_pecmail = 'send_mail_pecmail',
    get_sent_items_pecmail = 'get_sent_items_pecmail',
    get_ricevute_pecmail = 'get_ricevute_pecmail',
    get_mail_by_id_pecmail = 'get_mail_by_id_pecmail',
    get_mail_stati_ivio_pecmail = 'get_mail_stati_ivio_pecmail',
    get_all_folders_pecmail = 'get_all_folders_pecmail',
    get_mails_in_folder_pecmail = 'get_mails_in_folder_pecmail',
    get_base64_file = 'get_base64_file',
    get_pdf_corpo_mail = 'get_pdf_corpo_mail',
    set_mail_registered_pecmail = 'set_mail_registered_pecmail',
    send_notification = 'send_notification',
    convert_file = 'convert_file',
    delete_filing_plan = 'delete_filing_plan',
    update_filing_plan = 'update_filing_plan',
    update_uor = 'update_uor',
    delete_uor = 'delete_uor',
    updater = 'updater',
    delete_user = 'delete_user',
    update_user = 'update_user',
    get_all_user = 'get_all_user',
    add_user_sql_only = 'add_user_sql_only',
    create_daily_protocol_register = 'create_daily_protocol_register',
    create_annual_protocol_register = 'create_annual_protocol_register',
    add_user_notifications = 'add_user_notifications',
    get_user_by_uor = 'get_user_by_uor',
    update_user_notifications = 'update_user_notifications',
    delete_user_notifications = 'delete_user_notifications',
    get_all_uors_for_currentuser_selected_aoo = 'get_all_uors_for_currentuser_selected_aoo',
    get_user_uors_with_operator_role_selected_aoo = 'get_user_uors_with_operator_role_selected_aoo',
    get_print_and_send_spedizioni = 'get_print_and_send_spedizioni',
    get_codici_lavorazione_print_and_send = 'get_codici_lavorazione_print_and_send',
    add_print_and_send = 'add_print_and_send',
    get_print_and_send_stato_spedizione = 'get_print_and_send_stato_spedizione',
    update_print_and_send = 'update_print_and_send',
    get_exhibition_documents = 'get_exhibition_documents',
    exhibition_request = 'exhibition_request',
    sign_document = 'sign_document',
    get_protocol_references = 'get_protocol_references',
    create_protocol_reference = 'create_protocol_reference',
    delete_protocol_reference = 'delete_protocol_reference',
    create_ricevuta_protocollazione = 'create_ricevuta_protocollazione',
    update_ricevuta_protocollazione = 'update_ricevuta_protocollazione',
    create_immediate_notification = 'create_immediate_notification',
    update_immediate_notification = 'update_immediate_notification',
    update_notification_queue = 'update_notification_queue',
    search_indice_pa = 'search_indice_pa',
    get_ente_pa = 'get_ente_pa',
    get_protocol_registers = 'get_protocol_registers',
    get_protocol_register_file = 'get_protocol_register_file',
    get_versioni_docset = 'get_versioni_docset',
    get_fascicoli = 'get_fascicoli',
    get_fascicolo = 'get_fascicolo',
    create_fascicolo = 'create_fascicolo',
    update_fascicolo = 'update_fascicolo',
    delete_fascicolo = 'delete_fascicolo',
    close_fascicolo = 'close_fascicolo',
    open_fascicolo = 'open_fascicolo',
    get_protocolli_fascicolo = 'get_protocolli_fascicolo',
    get_fascicoli_protocollo = 'get_fascicoli_protocollo',
    add_protocol_to_fascicolo = 'add_protocol_to_fascicolo',
    remove_protocol_from_fascicolo = 'remove_protocol_from_fascicolo',
    get_protocol_dispatches = 'get_protocol_dispatches',
    get_protocol_dispatch = 'get_protocol_dispatch',
    add_protocol_dispatches = 'add_protocol_dispatches',
    update_protocol_dispatches = 'update_protocol_dispatches',
    delete_protocol_dispatches = 'delete_protocol_dispatches',
    get_mailboxes = 'get_mailboxes',
    create_mailbox = 'create_mailbox',
    delete_mailbox = 'delete_mailbox',
    update_mailbox = 'update_mailbox',
    save_acquired_protocol = 'save_acquired_protocol',
    protocol_acquired_protocol = 'protocol_acquired_protocol',
    create_allocated_protocol = 'create_allocated_protocol',
    get_protocols_workspace = 'get_protocols_workspace',
    get_protocol_workspace = 'get_protocol_workspace',
    add_protocol_workspace = 'add_protocol_workspace',
    update_protocol_workspace = 'update_protocol_workspace',
    delete_protocol_workspace = 'delete_protocol_workspace',
    start_processing_protocol_workspace = 'start_processing_protocol_workspace',
    end_processing_protocol_workspace = 'end_processing_protocol_workspace',
    reset_processing_protocol_workspace = 'reset_processing_protocol_workspace',
    assignment_protocol_workspace = 'assignment_protocol_workspace',
    get_users_aoo = 'get_users_aoo',
    add_user_aoo = 'add_user_aoo',
    update_user_aoo = 'update_user_aoo',
    delete_user_aoo = 'delete_user_aoo',
    get_undo_request = 'get_undo_request',
    add_undo_request = 'add_undo_request',
    update_undo_request = 'update_undo_request',
    approve_undo_request = 'approve_undo_request',
    reject_undo_request = 'reject_undo_request',
    annulla_undo_request = 'annulla_undo_request',
    retry_incomplete_operations = 'retry_incomplete_operations',
    get_signature_for_protocol = 'get_signature_for_protocol',
    get_contact_suggestions = 'get_contact_suggestions',
    get_contact_info = 'get_contact_info',
    get_protocol_files_as_zip = 'get_protocol_files_as_zip',
    get_filing_plan_suggestions = 'get_filing_plan_suggestions',
    get_protocol_annotations = 'get_protocol_annotations',
    add_protocol_annotation = 'add_protocol_annotation',
    get_searchAi_fields = 'get_searchAi_fields',
    installer_CreateAOO = 'installer_CreateAOO',
    installer_InstallEvent = 'installer_InstallEvent',
    get_colonne_generali = 'get_colonne_generali',
    get_colonna_generale = 'get_colonna_generale',
    update_colonna_generale = 'update_colonna_generale',
    create_colonna_generale = 'create_colonna_generale',
    delete_colonna_generale = 'delete_colonna_generale',
    get_aoo_protocol_views = 'get_aoo_protocol_views',
    get_aoo_protocol_view = 'get_aoo_protocol_view',
    update_aoo_protocol_view = 'update_aoo_protocol_view',
    create_aoo_protocol_view = 'create_aoo_protocol_view',
    delete_aoo_protocol_view = 'delete_aoo_protocol_view',
    get_eml_by_id_pecmail = 'get_eml_by_id_pecmail',
    create_protocol_draft_ia = 'create_protocol_draft_ia',
    create_protocol_ia = 'create_protocol_ia',
    register_protocol_ia = 'register_protocol_ia',
    get_protocol_summary_ia = 'get_protocol_summary_ia'
}

